<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-body tab2-card">
<!--                    <form [formGroup]="serviceDeskEmailForm" class="needs-validation">-->
                        <div class="card-header">
                            <div class="form-group row justify-content-md-center">
                              <div class="center-item" style=" align-content: center; text-align: center">
                                <div placement="bottom" class="d-inline-block dropdown alert alert-warning"
                                     style="align-content: center; text-align: center;">
                                  <span>
                                    Dacă doriţi să semnalaţi probleme legate de funcţionarea POSF din punct de vedere
                                    tehnic vă rugăm să transmiteţi un mail la adresa de email: <a href="mailto:servicedesk@anre.ro?subject=[ClientFinal]">servicedesk@anre.ro</a> .
                                    Cu titlu de exemplu se identifică: erori generate de POSF în modulul “client final”, blocarea paginii,
                                    lipsă afisare date de identificare dupa completarea acestora, etc..
                                    Pentru orice alte sesizari, va rugam sa accesati canalele alternative puse la dispozitia dumneavoastra pe pagina de internet a ANRE
                                    <a href="https://www.anre.ro" target="_blank">www.anre.ro</a> .
                                  </span>
<!--                                  În această pagină puteţi semnala exclusiv problemele legate de funcţionarea POSF din punct de vedere tehnic. Cu titlu de exemplu se identifică: erori generate de POSF în modulul “client final”, blocarea paginii, lipsă afisare date de identificare dupa completarea acestora, etc.. Pentru orice alte sesizari, va rugam sa accesati canalele alternative puse la dispozitia dumneavoastra pe pagina de internet a ANRE <a href="https://www.anre.ro" target="_blank">www.anre.ro</a> .-->
                                </div>
                              </div>
                            </div>
                            <!--<div class="form-group row">
                                <div class="col">
                                    <label>{{user}}:</label>
                                    <input class="form-control" type="text" formControlName="from" required />
                                </div>
                            </div>
                            <div class="form-group row">
                              <div class="col">
                                <label>{{problematica}}:</label>
                                <select class="form-control" type="text" formControlName="problematica" >
                                  <option value="" disabled selected>Selecteaza o problematica</option>
                                  <option *ngFor="let problem of listOfProblemTypes">{{problem}}</option>
&lt;!&ndash;                                  <option>Solicitare credentiale broker API</option>&ndash;&gt;
&lt;!&ndash;                                  <option>Raportare bug platforma web</option>&ndash;&gt;
&lt;!&ndash;                                  <option>Propunere imbunatatire platforma</option>&ndash;&gt;
&lt;!&ndash;                                  <option>Alta problematica</option>&ndash;&gt;
                                </select>
                              </div>
                            </div>
                            <div class="form-group row">
                                <div class="col">
                                    <label>{{subject}}:</label>
                                    <input class="form-control" type="text" formControlName="subject" required />
                                </div>
                            </div>
                            <div class="form-group row">
                                <div class="col">
                                    <label>{{description}}:</label>
                                    <textarea style="width : 100%" rows="12" formControlName="description"
                                        required></textarea>
                                </div>
                            </div>
                        </div>-->
                        <div class="centered">
                            <!--<button type="button" class="btn btn-primary mr-1"
                                (click)="onSendingMail()">Trimite</button>-->
                          <button type="button" class="btn btn-primary mr-1"
                                (click)="onCancel()">Închide</button>
                        </div>
<!--                    </form>-->
                </div>
            </div>
        </div>
    </div>
